module.exports = __webpack_public_path__ + "static/media/Jhon.032c17c5.png";